import React from 'react';
import { Mail, Phone, Linkedin, ArrowUpRight } from 'lucide-react';
import Magnetic from '../motion/Magnetic';
import '../../styles/contact.css';

const methods = [
  {
    icon: Mail,
    label: 'Email',
    value: 'kevin.gelineau90@gmail.com',
    href: 'mailto:kevin.gelineau90@gmail.com'
  },
  { icon: Phone, label: 'Téléphone', value: '06 50 92 30 84', href: 'tel:+33650923084' },
  {
    icon: Linkedin,
    label: 'LinkedIn',
    value: 'in/kevin-gelineau',
    href: 'https://www.linkedin.com/in/kevin-gelineau/',
    external: true
  }
];

const Contact = () => (
  <section className="section contact" id="contact">
    <div className="shell">
      <h2 className="contact-title">
        Travaillons
        <br />
        ensemble
      </h2>

      <div className="contact-cta">
        <Magnetic strength={0.25}>
          <a href="mailto:kevin.gelineau90@gmail.com" className="contact-button">
            <span>Démarrer une conversation</span>
            <ArrowUpRight size={20} aria-hidden="true" />
          </a>
        </Magnetic>
        <p className="contact-note">Réponse habituelle sous 24 h</p>
      </div>

      <ul className="contact-list">
        {methods.map((m, i) => {
          const Icon = m.icon;
          return (
            <li key={m.label}>
              <a
                href={m.href}
                className="contact-row"
                target={m.external ? '_blank' : undefined}
                rel={m.external ? 'noopener noreferrer' : undefined}
              >
                <Icon size={16} className="contact-row-icon" aria-hidden="true" />
                <span className="contact-row-label">{m.label}</span>
                <span className="contact-row-value">{m.value}</span>
                <ArrowUpRight size={16} className="contact-row-arrow" aria-hidden="true" />
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  </section>
);

export default Contact;
